export default class DtoFileData {
    constructor(obj = {}) {
        this.stringValue = obj.stringValue // Option[String]
        this.dateValue = obj.dateValue // Option[DateTime]
        this.value = obj.value // Option[Double]
    }
}
